import { z } from 'zod/v4'

export const baseModelSchema = z.object({
  id: z.uuid(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
})
export type BaseModel = z.infer<typeof baseModelSchema>
